import { render, staticRenderFns } from "./PricingPlanValidationDialog.vue?vue&type=template&id=22a498fa"
import script from "./PricingPlanValidationDialog.vue?vue&type=script&lang=ts"
export * from "./PricingPlanValidationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports